<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="loaded">
    <div class="container">
      <div class="titulo mb-5" v-html="titulo"></div>
      <div class="subtitulo mt-2 mb-3" v-html="subtitulo"></div>
      <button class="modal-btn" @click="mt_closeModal">OK</button>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['dialogRef'],
  components: {},
  data() {
    return {
      loaded: false,
      titulo: this.dialogRef.data.titulo,
      subtitulo: this.dialogRef.data.subtitulo,
    };
  },
  computed: {},
  methods: {
    mt_start() {
      this.loaded = true;
    },
    mt_closeModal() {
      this.dialogRef.close();
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<style scoped>
.container {
  text-align: center;
  padding:10px 15px;
}
.titulo {
  font-size:22px;
}
.subtitulo {
  font-size:16px;
}
.modal-btn {
  position: relative;
  font-size: 15px;
  color: #ffffff;
  line-height: 24px;
  width: max-content;
  padding: 8px 30px;
  background: var(--ibase-color);
  border: 2px solid var(--ibase-color);
  font-weight: 500;
  border-radius: 50px;
  box-shadow: 0 18px 22px rgba(0, 0, 0, .1);
  cursor: pointer;
  max-height: 60px;
  transition: all 300ms ease;
}
.modal-btn:hover {
  color: var(--ibase-color);
  background: #fff;
}
</style>
